var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewTime = function SvgNewTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "4 -6 20 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_686",
    "data-name": "Grupo 686",
    transform: "translate(-965.192 -229.2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 13.181,
    cy: 13.182,
    rx: 13.181,
    ry: 13.182,
    transform: "translate(966.042 230.05)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_273",
    "data-name": "Grupo 273",
    transform: "translate(979.037 236.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M.055,8.46,0,0",
    fill: "#7d7d7d",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_81",
    "data-name": "Linha 81",
    x2: 9.132,
    transform: "translate(0 7.935)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_82",
    "data-name": "Linha 82",
    y2: 2.19,
    transform: "translate(979.224 230.05)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_83",
    "data-name": "Linha 83",
    y2: 2.17,
    transform: "translate(979.224 254.149)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_84",
    "data-name": "Linha 84",
    x1: 2.202,
    transform: "translate(966.042 243.232)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_85",
    "data-name": "Linha 85",
    x1: 2.13,
    transform: "translate(990.151 243.232)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_time.1dcfda70.svg";
export { ForwardRef as ReactComponent };